import { createVNode as n, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/EnterpriseManageFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return n(d, i(a, {
    icon: o
  }), null);
};
r.displayName = "EnterpriseManageFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
